import React, { } from 'react'
import { useSelector } from 'react-redux'

import { SharePostDialogContent } from '../pages/profile/posts/view/SharePostDialog'

import { postUrl } from 'lib/postUrl'
import { selectForResponseTools } from './ResponseTools'
import { ShareIcon } from 'core/icons'
import { Dialog, DialogContent, IconButton, ListItemIcon, ListItemText, MenuItem } from '@material-ui/core'
import { DialogIcon, DialogTitle } from 'profile/DialogTitle'
import { usePostContext } from 'posts/PostContext'


export const ShareIconButton = () => {
    const { post } = useSelector(selectForResponseTools)
    const [closed, setClosed] = React.useState<boolean>(true)
    const { post: response } = usePostContext()
    if (post.completed || response.unpublished) {
        return null
    }

    return (
        <>
            <MenuItem
                onClick={(ev: React.MouseEvent) => {
                    ev.stopPropagation()
                    setClosed(false)
                }}
            >
                <ListItemIcon>
                    <IconButton
                        aria-label="show members"
                        color="inherit"
                    >
                        <ShareIcon />
                    </IconButton>
                </ListItemIcon>
                <ListItemText primary={"Share..."} />
            </MenuItem>
            <ShareDialog closed={closed} setClosed={setClosed} />
        </>
    )
}

export const ShareDialog = ({ closed, setClosed }: { closed, setClosed }) => {
    const { post, domainName } = useSelector(selectForResponseTools)

    const author = post?.author
    const url = postUrl({ domainName, userName: post.author.username, postId: post.name })

    if (closed || !author?.username) {
        return null
    }

    return (
        <Dialog
            onClose={() => setClosed(true)}
            aria-labelledby="customized-dialog-title"
            open={!closed}
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
        >
            <DialogTitle
                icon={<DialogIcon><ShareIcon /></DialogIcon>}
                data-testid="customized-dialog-title"
                onClose={() => setClosed(true)}
            >
                Share post
            </DialogTitle>
            <DialogContent dividers>
                <SharePostDialogContent url={url} post={post} author={author} />
            </DialogContent>
        </Dialog>

    )
}

